import { TTransshipmentStepId } from '../../types';

const step = {
  path: 'documentos/tipo',
  next: (trans): TTransshipmentStepId =>
    trans.identityDocumentType === 'cnh' ? 'cnh-page' : 'rg-page',
};

export default step;
